import _toConsumableArray from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var T = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
  },
  _ = function _(r) {
    return function () {
      for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
        t[_key] = arguments[_key];
      }
      return {
        _$litDirective$: r,
        values: t
      };
    };
  };
var i = /*#__PURE__*/function () {
  function i(t) {
    _classCallCheck(this, i);
  }
  _createClass(i, [{
    key: "_$AT",
    value: function _$AT(t, e, s) {
      this._$Ct = t, this._$AM = e, this._$Ci = s;
    }
  }, {
    key: "_$AS",
    value: function _$AS(t, e) {
      return this.update(t, e);
    }
  }, {
    key: "update",
    value: function update(t, e) {
      return this.render.apply(this, _toConsumableArray(e));
    }
  }, {
    key: "_$AU",
    get: function get() {
      return this._$AM._$AU;
    }
  }]);
  return i;
}();
export { _ as T, i as _, T as s };